import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { readOfflineScopes } from '@/features/events/offline/locators';

// The offline workspace runs signed out and without a network, so it cannot ask the API about the
// flag. A prepared scope can only exist on a device whose user already had event access, so the
// scopes stand in for the flag here.
export default function RequirePreparedOfflineEvents({ children }: { children?: ReactNode }) {
  if (readOfflineScopes().length === 0) return <Navigate to="/" replace />;

  return children ?? <Outlet />;
}
